import Vue from 'vue';

const END_POINT = "/packingList";

const saveWorksheetAsPackingList = data => Vue.axios.post(END_POINT + "/from-worksheet", data);

export {
    saveWorksheetAsPackingList
}